import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CalculatorsPage } from './pages/Calculators';
import { CalculatorsEmbedPage } from './pages/CalculatorsEmbed';

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/calculators" replace />} />
      <Route path="/calculators" element={<CalculatorsPage />} />
      <Route path="/calculators/embed" element={<CalculatorsEmbedPage />} />
      <Route path="*" element={<Navigate to="/calculators" replace />} />
    </Routes>
  );
};

